import env from '../config/env';
import { postBodyService } from "./base.service";
import config from "../config/application";
import permission from '../api/permissions.service';
import dictionary from '../config/dictionary';

//url
const summaryReport = 'open_document_data';
const summaryRow = 'countPage';

class SummaryService {
    async getSummaryTotal(json, username) {
        let valid = await permission.validPermission(
            env.transaction.summary,
            username,
            env.app.systemCode, dictionary.configApp.action.list);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.income.summary.url}${summaryReport}`;
            return postBodyService(url, json);
        } else {
            return valid;
        }
    }
    async getRowTotal(json) {
        const url = `${config.data.income.summary.url}${summaryRow}`;
        return postBodyService(url, json);
    }
}

export default new SummaryService();